module.exports = __webpack_public_path__ + "img/cuttingboard_thumb.070664a0.jpg";